import { createI18n } from 'vue-i18n'

const SUPPORTED_LOCALES = ['zh-cn', 'en'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

/** 根据浏览器语言得到默认 locale：中文用 zh-cn，其余用 en */
const getBrowserLocale = (): string => {
  const lang = typeof navigator !== 'undefined' ? navigator.language : ''
  const lower = lang.toLowerCase()
  if (lower.startsWith('zh')) return 'zh-cn'
  return 'en'
}

const LOCALE_STORAGE_KEY = 'app-locale'

/** 获取当前语言：优先本地存储，否则按浏览器语言；无存储时会把浏览器语言写入存储 */
export const getInitialLocale = (): string => {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
    if (stored && SUPPORTED_LOCALES.includes(stored as SupportedLocale)) {
      return stored
    }
    const browserLocale = getBrowserLocale()
    localStorage.setItem(LOCALE_STORAGE_KEY, browserLocale)
    return browserLocale
  } catch (error) {
    console.error('读取语言设置失败:', error)
  }
  return getBrowserLocale()
}

export const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'zh-cn',
  messages: {},
})

const loadedLocales = new Set<string>()

/** 按需加载语言包并写入 i18n，切换语言前调用 */
export const loadLocaleMessages = async (locale: string): Promise<void> => {
  if (loadedLocales.has(locale)) return
  if (locale === 'zh-cn') {
    const m = await import('./locales/zh-cn/index.ts')
    i18n.global.setLocaleMessage('zh-cn', m.default)
  } else {
    const m = await import('./locales/en/index.ts')
    i18n.global.setLocaleMessage('en', m.default)
  }
  loadedLocales.add(locale)
}
